/** @jsx jsx */
import { Button, Flex } from '@bottlebooks/gatsby-theme-base';
import { jsx } from 'theme-ui';
import search from '../../assets/search.svg';

const variants = {
  largest: { borderRadius: 'default' },
};

const imgVariants = {
  default: { width: 16, height: 16 },
  largest: { width: 32, height: 32, marginLeft: 3 },
};

const inputVariants = {
  default: {
    variant: 'text.default',
    paddingX: 2,
    paddingY: 1,
    '::placeholder': {
      color: 'lightestText',
    },
  },
  largest: {
    variant: 'text.default',
    fontWeight: 'lowContrast',
    paddingX: 2,
    paddingY: 3,
    '::placeholder': {
      color: 'lightestText',
    },
  },
};

const buttonVariants = {
  default: { paddingX: 2, paddingY: 1 },
  largest: { padding: 3, marginX: 2 },
};

export default function FilterField({
  value,
  onChange,
  variant = 'default',
  className = undefined,
  ...rest
}) {
  return (
    <Flex
      sx={{
        alignItems: 'center',
        border: 1,
        borderColor: 'border',
        ...(variants[variant] || variants.default),
      }}
      className={className}
    >
      <img
        src={search}
        width="16"
        height="16"
        alt=""
        sx={{ margin: 2, ...(imgVariants[variant] || imgVariants.default) }}
      />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          flex: 1,
          paddingX: 2,
          paddingY: 1,
          border: 0,
          outline: 'none',
          ...(inputVariants[variant] || inputVariants.default),
        }}
        {...rest}
      />
      {value && (
        <Button
          onClick={() => onChange('')}
          variant="text"
          sx={{
            color: 'lightText',
            ...(buttonVariants[variant] || buttonVariants.default),
          }}
        >
          ✕
        </Button>
      )}
    </Flex>
  );
}
